<template>
  <div class="s-personalCenter-container">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>

    <div class="s-personalCenter-body w1300">
      <div class="s-personalCenter-left-nav">
        <div
          v-for="(item, index) in leftNav"
          :key="index"
          :class="[currentLeftNav == item ? 's-left-nav-active' : '']"
          @click="handleLeftNav(item)"
        >
          {{ item }}
        </div>
      </div>
      <div class="s-personalCenter-right">
        <experts-end
          :isExpert="isExpert"
          v-if="isExpert == 'true' && currentLeftNav == '我的问题'"
        ></experts-end>
        <visitor-end
          :isExpert="isExpert"
          v-if="isExpert == 'false' && currentLeftNav == '我的提问'"
        ></visitor-end>
        <my-submission v-if="currentLeftNav == '我的提交'"></my-submission>
        <my-application v-if="currentLeftNav == '我的申请'"></my-application>

        <!-- <my-application v-if="currentLeftNav == '我的申请'"></my-application> -->

        <my-video v-if="currentLeftNav == '我的视频'" ref="videoAdviceList"></my-video>

      </div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import expertsEnd from "../components/expertsEnd.vue";
import visitorEnd from "../components/visitorEnd.vue";
import mySubmission from "../components/mySubmission.vue";
import myApplication from "../components/myApplication.vue";
import myVideo from "../components/myVideo.vue";
export default {
  name: "personalCenter",
  components: {
    topNav,
    footerNav,
    expertsEnd,
    visitorEnd,
    mySubmission,
    myApplication,
    myVideo
  },
  data() {
    return {
      leftVisitorNav: ["我的申请", "我的提问", "我的提交"],
      leftExpertNav: ["我的申请", "我的问题", "我的提交", "我的视频"],
      currentLeftNav: "我的申请",
      leftNav: [],
      isExpert: "false", // 普通用户
    };
  },
  mounted() {
    this.isExpert = localStorage.getItem("isExpert");
    if (JSON.parse(this.$store.state.isLogin)) {
      if (this.isExpert == "false") {
        this.leftNav = this.leftVisitorNav;
      } else {
        this.leftNav = this.leftExpertNav;
      }
    }

  },
  methods: {
    handleLeftNav(item) {
      this.currentLeftNav = item;
    },

    getMyExpertId(){
      let myExpertId = this.$parent.myExpertId
      return myExpertId
    },
    getVideoPlay(){
      this.$emit('videoPlay')
    },
    getData() {
      if(this.$refs['videoAdviceList'].getItem){
        let exportId = this.$refs['videoAdviceList'].exportId
        let line_type = this.$refs['videoAdviceList'].line_type
        return {
          exportId,
          line_type
        }
      } else {
        let exportId2 = this.$refs['videoAdviceList'].exportId
        let line_type2 = this.$refs['videoAdviceList'].line_type
        return {
          exportId2,
          line_type2
        }
      }

    },

  },
};
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
@import "../utils/css/personalCenter.scss";
</style>
